// extracted by mini-css-extract-plugin
module.exports = {"acceptedSpan":"handshake_utils-module_acceptedSpan_47101","rejectedSpan":"handshake_utils-module_rejectedSpan_2eb80","revokeButton":"handshake_utils-module_revokeButton_1f876"};